module.exports = __webpack_public_path__ + "static/media/logo_pink.ad779986.png";